import React, { Component } from 'react';
import { connect } from 'react-redux';
import clone from 'ramda/src/clone';
import descend from 'ramda/src/descend';
import find from 'ramda/src/find';
import isNil from 'ramda/src/isNil';
import propEq from 'ramda/src/propEq';
import prop from 'ramda/src/prop';
import sortWith from 'ramda/src/sortWith';
import length from 'ramda/src/length';
import moment from 'moment';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import HabitItem from '@components/@core/HabitItem';
import Pagination from '@components/@core/Pagination';
import TaskHeader from '@components/@core/TaskHeader';
import TaskItem from '@components/@core/TaskItem';
import TaskReport from '@components/TaskReport';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';
import withNavigate from '~/hocs/withNavigate';
import { inPage } from '~/services/util';

class IndividualTask extends Component {
    state = {
        dateStart: moment().startOf('month').format('YYYY-MM-DD'),
        dateEnd: moment().endOf('month').format('YYYY-MM-DD'),
        incompletedTasks: [],
        completedTasks: [],
        dailyHabits: [],
        weeklyHabits: [],
        monthlyHabits: [],
        userId: Number(this.props.params?.id || 0),
        companyId: this.props.companyId === -1 ? this.props.companyId : this.props.companyId,
        current1: 1,
        current2: 1,
        current3: 1,
        current4: 1,
        current5: 1,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { tasks, projects } = nextProps;
        const _tasks = clone(tasks);

        const incompletedTasks = [];
        const completedTasks = [];
        const dailyHabits = [];
        const weeklyHabits = [];
        const monthlyHabits = [];

        if (projects.length > 0) {
            _tasks.tasksCard.data.forEach((task) => {
                const projectId = isNil(task.project_id) ? 166 : task.project_id;
                const project = find(propEq('id', projectId), projects) || {};
                task.project = project;
                if (isNil(task.completed_at)) {
                    incompletedTasks.push(task);
                } else {
                    const isBetween = moment(task.completed_at).isBetween(prevState.dateStart, prevState.dateEnd);
                    isBetween && completedTasks.push(task);
                }
            });

            _tasks.habitsCard.forEach((habit) => {
                const projectId = isNil(habit.project_id) ? 166 : habit.project_id;
                const project = find(propEq('id', projectId), projects) || {};
                habit.project = project;
                if (habit.data.schedule_interval === 'day') {
                    dailyHabits.push(habit);
                } else if (habit.data.schedule_interval === 'week') {
                    weeklyHabits.push(habit);
                } else if (habit.data.schedule_interval === 'month') {
                    monthlyHabits.push(habit);
                }
            });
        }

        return { incompletedTasks, completedTasks, dailyHabits, weeklyHabits, monthlyHabits };
    }

    componentDidMount() {
        const { userId, dateStart, dateEnd } = this.state;
        this.props.getTasks(userId, { page: 1, perPage: 5000, dateStart, dateEnd });
    }

    handleFilter = (type, e) => {
        const { companyId, dateStart, dateEnd } = this.state;

        if (isNil(e)) return;
        if (type === 'employee') {
            const userId = e[0].id;
            if (userId > 0) {
                this.props.getTasks(userId, { page: 1, perPage: 5000, dateStart, dateEnd });
                const payload = { companyId: [companyId], userId, dateStart, dateEnd };
                this.props.getReports(payload);
                this.setState({ userId });
            }
        } else {
            if (e[0].id < 0) return;
            this.setState({ companyId: e[0].id });
        }
    };

    handleUpdateHabit = (checked, id) => {
        if (checked) {
            this.props.updateTask('completed', id);
        } else {
            this.props.updateTask('incompleted', id);
        }
    };

    handleReport = (dateStart, dateEnd) => {
        const { userId, companyId } = this.state;
        this.props.getTasks(userId, { page: 1, perPage: 5000, dateStart, dateEnd });
        const payload = { companyId: [companyId], userId, dateStart, dateEnd };
        this.props.getReports(payload);
        this.setState({ dateStart, dateEnd });
    };

    render() {
        const { reports } = this.props;
        const { userId, incompletedTasks, dailyHabits, weeklyHabits, monthlyHabits, current1, current2, current3, current4, current5 } = this.state;
        const completedTasks = sortWith([descend(prop('completed_at'))], this.state.completedTasks);

        return (
            <ErrorBoundary className="reports-task-detail">
                <Filter back="company task reports" onChange={this.handleFilter} />
                <TaskReport
                    data={reports}
                    selected={[userId]}
                    individualTaskData={{
                        incompletedTasks,
                        completedTasks,
                        dailyHabits,
                    }}
                    onTasks={this.handleReport}
                    onModal={(e) => this.props.toggleModal(e)}
                />

                <div className="mt-2 d-block d-lg-flex">
                    <div className="d-flex-1 custom-margin-right">
                        {incompletedTasks.length > 0 && (
                            <div className="card mt-2 pt-0 pb-4">
                                <TaskHeader title="Incomplete Tasks" className="p-3" />
                                <div className="box-detail" id="incompleteTask">
                                    {incompletedTasks.map((task, index) => {
                                        if (inPage(index, current1, 15)) return <TaskItem className="reports-task-item" key={task.id} task={task} />;
                                    })}
                                </div>
                                {incompletedTasks.length >= 15 && (
                                    <Pagination dataCy="incompleteTask" current={current1} total={Math.ceil(length(incompletedTasks) / 15)} onChange={(e) => this.setState({ current1: e })} />
                                )}
                            </div>
                        )}
                        {dailyHabits.length > 0 && (
                            <div className="card mt-2 pt-0 pb-4">
                                <TaskHeader title="Daily Habits" className="p-3" />
                                <div className="box-detail" id="dailyhabitstask">
                                    {dailyHabits.map((task) => (
                                        <HabitItem
                                            key={task.id}
                                            type="Daily"
                                            habit={task}
                                            project={task.project}
                                            status={reports.individuals[0].habits[task.data.schedule_id]}
                                            onModal={(e) => this.props.toggleModal(e)}
                                            onUpdate={this.handleUpdateHabit}
                                        />
                                    ))}
                                </div>
                                {dailyHabits.length >= 15 && (
                                    <Pagination dataCy="dailyhabitstask" current={current2} total={Math.ceil(length(dailyHabits) / 15)} onChange={(e) => this.setState({ current2: e })} />
                                )}
                            </div>
                        )}
                        {weeklyHabits.length > 0 && (
                            <div className="card mt-2 pt-0 pb-4">
                                <TaskHeader title="Weekly Habits" className="p-3" />
                                <div className="box-detail" id="weeklyhabit">
                                    {weeklyHabits.map((task) => (
                                        <HabitItem
                                            key={task.id}
                                            type="Weekly"
                                            habit={task}
                                            project={task.project}
                                            status={reports.individuals[0].habits[task.data.schedule_id]}
                                            onModal={(e) => this.props.toggleModal(e)}
                                            onUpdate={this.handleUpdateHabit}
                                        />
                                    ))}
                                </div>
                                {weeklyHabits.length >= 15 && (
                                    <Pagination dataCy="weeklyhabit" current={current3} total={Math.ceil(length(weeklyHabits) / 15)} onChange={(e) => this.setState({ current3: e })} />
                                )}
                            </div>
                        )}
                        {monthlyHabits.length > 0 && (
                            <div className="card mt-2 pt-0 pb-4">
                                <TaskHeader title="Monthly Habits" className="p-3" />
                                <div className="box-detail" id="monthlyhabit">
                                    {monthlyHabits.map((task) => (
                                        <HabitItem
                                            key={task.id}
                                            type="Monthly"
                                            habit={task}
                                            project={task.project}
                                            status={reports.individuals[0].habits[task.data.schedule_id]}
                                            onModal={(e) => this.props.toggleModal(e)}
                                            onUpdate={this.handleUpdateHabit}
                                        />
                                    ))}
                                </div>
                                {monthlyHabits.length >= 15 && <Pagination current={current4} total={Math.ceil(length(monthlyHabits) / 15)} onChange={(e) => this.setState({ current4: e })} />}
                            </div>
                        )}
                    </div>
                    <div className="d-flex-1 custom-margin-left">
                        {completedTasks.length > 0 && (
                            <div className="card mt-2 pt-0 pb-4 py-0">
                                <TaskHeader title="Completed Tasks" className="p-3" />
                                <div className="box-detail" id="completetask">
                                    {completedTasks.map((task) => (
                                        <TaskItem className="reports-task-item" task={task} key={task.id} />
                                    ))}
                                </div>
                                {completedTasks.length >= 15 && <Pagination current={current5} total={Math.ceil(length(completedTasks) / 15)} onChange={(e) => this.setState({ current5: e })} />}
                            </div>
                        )}
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.app.id,
    companyId: state.app.selectedCompany[0] || state.app.company_info.id,
    reports: state.manage.tasksReport,
    projects: state.app.projects,
    tasks: state.manage.tasksData,
});

const mapDispatchToProps = (dispatch) => ({
    getTasks: (userId, e) => dispatch(ManageActions.gettasksfeedRequest(userId, e)),
    getReports: (payload) => dispatch(ManageActions.companyindividualRequest(payload)),
    updateTask: (type, cardId) => dispatch(ManageActions.updatetaskRequest(type, cardId)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const IndividualTaskWithNavigate = withNavigate(IndividualTask);
export default connect(mapStateToProps, mapDispatchToProps)(IndividualTaskWithNavigate);
